import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthService } from './../../../services/auth.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [],
})
export class AppHeaderComponent {
  username;
  path: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this.username = localStorage.getItem('username');

    if (this.username == 'ITZ_ABREGO') {
      this.path = 'assets/images/users/itzel.jpeg';
    } else if (this.username == 'JESUS_HUERTA') {
      this.path = 'assets/images/users/mario.jpg';
    } else if (this.username == 'SIMON') {
      this.path = 'assets/images/users/bruno.JPG';
    } else if (this.username == 'AHURI_ADMIN') {
      this.path = 'assets/images/users/Ahuri.png';
    } else {
      this.path = 'assets/images/users/9.png';
    }
  }
  logout() {
    this.authService.logout();
    this.toastr.success('Sesión cerrada exitosamente', 'Success');
    this.router.navigate(['/login']);
  }
}
